const QuestionnaireName = Object.freeze({
    Character_structure_Wilhelm_Reich: 0,
    0:"Character_structure_Wilhelm_Reich"
});

export default QuestionnaireName;